
<div
#elPosContainer
class="pos-container"
>
  <p *ngIf="!isLocked" class="sr-only" [id]="getInstructionsId()">{{ getSelectionInstructions() }}</p>
  <p class="sr-only" aria-live="polite" aria-atomic="true" data-ui-name="Live Message" data-ui-component="element-render-matching" data-testid="element-render-matching-live-message">{{ liveMessage }}</p>

  <div cdkDropListGroup class="">
    <div class="drag-drop-containe">
      <div
        style="display: flex;
        flex-direction: row;
        flex: 1 1 0%;
        align-items: flex-start;
        flex-wrap: wrap;
        border: unset;
        height: 100%;"
        cdkDropList
        [cdkDropListData]="draggables"
        class="drag-drop-list mb-3"
        [attr.tabindex]="isLocked ? null : 0"
        role="group"
        [attr.aria-label]="getSourceLabel()"
        [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
        (keyup.enter)="placeSelected(draggables, true)"
        #mainDraggables
        cdkDropListSortingDisabled
        (cdkDropListDropped)="drop($event)" data-ui-name="Div" data-ui-component="element-render-matching" data-testid="element-render-matching-div">
        <div class="drag-el" *ngFor="let elPos of draggables" cdkDracripg
          [attr.tabindex]="isLocked ? null : 0"
          role="button"
          [attr.aria-pressed]="isSelected(elPos) ? 'true' : 'false'"
          [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
          [attr.aria-disabled]="isLocked ? 'true' : null"
          (keyup.enter)="handleItemKeydown($event, elPos, draggables)"
          style="margin-right: 10px;" data-ui-name="Div" data-ui-component="element-render-matching" data-testid="element-render-matching-div-a054803">
            <element-render
              *ngIf="elPos.ref.element"
              [contentElement]="elPos.ref.element"
              [isLocked]="true"
              [questionState]="{}"
             data-ui-name="Element render" data-ui-component="element-render-matching" data-testid="element-render-matching-element-render"></element-render>
        </div>
      </div>
    </div>

    <div class="painting-sculpting-list">
      <div *ngIf="!element.isInstructionsDisabled" class="question-block-label mb-3" style="text-align: center; font-size:0.8em;"  > 
        <tra-md slug="txt_default_darg_match_instr"></tra-md>
      </div>
      <div class="drag-drop-container matching" *ngFor="let elPos of targets; index as idx">
        <div class="group-title" [id]="getTargetLabelId(idx)">
          <element-render
              *ngIf="elPos.ref.element"
              [contentElement]="elPos.ref.element"
              [isLocked]="true"
              [questionState]="{}"
           data-ui-name="Element render" data-ui-component="element-render-matching" data-testid="element-render-matching-element-render-element-render"></element-render>
        </div>

        <div
          cdkDropList
          [cdkDropListData]="element.targets[idx].groups"
          class="drag-drop-list"
          [attr.tabindex]="isLocked ? null : 0"
          role="group"
          [attr.aria-labelledby]="getTargetLabelId(idx)"
          [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
          (keyup.enter)="placeSelected(element.targets[idx].groups, false)"
          (cdkDropListDropped)="drop($event)" data-ui-name="Div" data-ui-component="element-render-matching" data-testid="element-render-matching-div-f47b62d">
          <div class="drag-el" *ngFor="let elPos of element.targets[idx].groups" cdkDrag
            [attr.tabindex]="isLocked ? null : 0"
            role="button"
            [attr.aria-pressed]="isSelected(elPos) ? 'true' : 'false'"
            [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
            [attr.aria-disabled]="isLocked ? 'true' : null"
            (keyup.enter)="handleItemKeydown($event, elPos, element.targets[idx].groups)"
            style="margin: 10px 0;" data-ui-name="Div" data-ui-component="element-render-matching" data-testid="element-render-matching-div-b42da53">
              <element-render
                *ngIf="elPos.ref.element"
                [contentElement]="elPos.ref.element"
                [isLocked]="true"
                [questionState]="{}"
               data-ui-name="Element render" data-ui-component="element-render-matching" data-testid="element-render-matching-element-render-57f61ab5"></element-render>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
